<script>

	export default {
		functional: true,
		props: {
			flex: {
				type: Number,
				default: 1
			}
		},
		render (h, ctx) {
			const { $style } = ctx
			const { flex } = ctx.props
			return (
				<div class={$style.column} {...ctx.data} style={{ flex }}>
					{ctx.children}
				</div>
			)
		}
	}

</script>

<style lang="scss" module>

	.column {
		flex:1;
	}

	.column + .column {
		margin-left:3rem;
	}

</style>



// WEBPACK FOOTER //
// src/components/Grid/Column.vue